<div class="exercise-grid">
  <article
    class="exercise-card"
    *ngFor="let exercise of visibleExercises; trackBy: trackByExerciseId"
    [class.exercise-card--selected]="isExerciseSelected(exercise)"
  >
    <div class="exercise-card__media">
      <ng-container *ngIf="isPairedExercise(exercise); else regularMedia">
        <div class="exercise-card__paired-media">
          <img
            [src]="
              getComponentImage(exercise.pairedExercise.firstExercise, exercise)
            "
            [alt]="exercise.pairedExercise.firstExercise.name"
            (error)="useFallbackImage($event, exercise)"
          />
          <img
            [src]="
              getComponentImage(
                exercise.pairedExercise.secondExercise,
                exercise
              )
            "
            [alt]="exercise.pairedExercise.secondExercise.name"
            (error)="useFallbackImage($event, exercise)"
          />
        </div>
      </ng-container>
      <ng-template #regularMedia>
        <img
          class="exercise-card__image"
          [class.exercise-card__image--artwork]="!hasThumbnail(exercise)"
          [src]="getExerciseImage(exercise)"
          [alt]="getExerciseName(exercise)"
          (error)="useFallbackImage($event, exercise)"
        />
      </ng-template>

      <div class="exercise-card__media-shade"></div>

      <div class="exercise-card__top-row">
        <span class="exercise-card__type">
          {{ getExerciseTypeLabel(exercise) }}
        </span>

        <div class="exercise-card__quick-actions">
          <button
            mat-icon-button
            class="card-icon-button"
            aria-label="Exercise actions"
            [matMenuTriggerFor]="exerciseMenu"
          >
            <mat-icon>more_horiz</mat-icon>
          </button>
        </div>
      </div>

      <button
        type="button"
        class="exercise-card__play"
        *ngIf="getPrimaryVideoUrl(exercise)"
        aria-label="Play exercise video"
        (click)="playVideo(getPrimaryVideoUrl(exercise))"
      >
        <mat-icon>play_arrow</mat-icon>
      </button>

      <label class="exercise-card__selection">
        <input
          type="checkbox"
          [checked]="isExerciseSelected(exercise)"
          [attr.aria-label]="'Select ' + getExerciseName(exercise)"
          (change)="updateSelectedExercise(exercise)"
        />
        <span class="exercise-card__selection-box" aria-hidden="true">
          <mat-icon>check</mat-icon>
        </span>
      </label>
    </div>

    <div class="exercise-card__content">
      <div>
        <div class="exercise-card__kind" *ngIf="isPairedExercise(exercise)">
          Paired exercise
        </div>
        <h3 class="exercise-card__title">{{ getExerciseName(exercise) }}</h3>
        <p class="exercise-card__description">
          {{ getExerciseDescription(exercise) }}
        </p>
      </div>

      <div class="exercise-card__details">
        <span>
          <mat-icon>tune</mat-icon>
          {{ getConfigCount(exercise) }}
          {{
            getConfigCount(exercise) === 1 ? "configuration" : "configurations"
          }}
        </span>
        <span *ngIf="getBodyPartLabel(exercise)">
          <mat-icon>accessibility_new</mat-icon>
          {{ getBodyPartLabel(exercise) }}
        </span>
        <span *ngIf="getPrimaryVideoUrl(exercise)">
          <mat-icon>videocam</mat-icon>
          Video
        </span>
      </div>
    </div>

    <mat-menu #exerciseMenu="matMenu">
      <a
        mat-menu-item
        *ngIf="!isPairedExercise(exercise)"
        [routerLink]="['/save-exercise']"
        [queryParams]="{ id: exercise.regularExercise.id }"
      >
        <mat-icon>edit</mat-icon>
        <span>Edit exercise</span>
      </a>
      <a
        mat-menu-item
        *ngIf="isPairedExercise(exercise)"
        [routerLink]="['/save-paired-exercise']"
        [queryParams]="{ id: exercise.pairedExercise.id }"
      >
        <mat-icon>edit</mat-icon>
        <span>Edit paired exercise</span>
      </a>
      <button
        mat-menu-item
        *ngIf="getPrimaryVideoUrl(exercise)"
        (click)="playVideo(getPrimaryVideoUrl(exercise))"
      >
        <mat-icon>play_circle_outline</mat-icon>
        <span>Play video</span>
      </button>
      <button
        mat-menu-item
        *ngIf="
          isPairedExercise(exercise) &&
          exercise.pairedExercise.secondExercise.videoUrl
        "
        (click)="playVideo(exercise.pairedExercise.secondExercise.videoUrl)"
      >
        <mat-icon>video_library</mat-icon>
        <span>Play right exercise video</span>
      </button>
      <button mat-menu-item (click)="openDeleteConfirmationDialog(exercise)">
        <mat-icon color="warn">delete_outline</mat-icon>
        <span>Delete exercise</span>
      </button>
    </mat-menu>
  </article>
</div>
